import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, CheckCircle } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageHero from '../components/PageHero';
import { Reveal, SectionRule } from '../components/motion';
import { companyInfo } from '../data/mock';

const empty = { name: '', email: '', company: '', phone: '', service: '', message: '' };

const ContactPage = () => {
  const [formData, setFormData] = useState(empty);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setSubmitted(true);
    setTimeout(() => { setSubmitted(false); setFormData(empty); }, 3000);
  };

  const details = [
    [Phone, 'Phone', companyInfo.phone, `tel:${companyInfo.phone}`],
    [Mail, 'Email', companyInfo.email, `mailto:${companyInfo.email}`],
    [Clock, 'Hours', 'Mon – Fri, 8:00 – 18:00'],
  ];

  return (
    <>
      <Navbar />
      <main>
        <PageHero index="03" eyebrow="Contact" title={['Let’s start a', '{{conversation.}}']}>
          Ready to transform your IT infrastructure? Tell us what you’re building and our experts will respond within one business day.
        </PageHero>

        <SectionRule index="01" label="Get in touch" />
        <section className="py-8">
          <div className="max-w-6xl mx-auto px-6 grid lg:grid-cols-12 gap-10">
            <div className="lg:col-span-5 space-y-12">
              <Reveal>
                <h2 className="font-mono-label text-[var(--red)] mb-6">Offices</h2>
                <ul className="divide-y divide-[var(--line)] border-y border-[var(--line)]">
                  {companyInfo.locations.map((l) => (
                    <li key={l.city} className="py-5 flex gap-4"><MapPin className="w-5 h-5 mt-1 text-[var(--red)] shrink-0" /><div><p className="font-display text-3xl">{l.city}, {l.country}</p><p className="text-sm text-[var(--muted)] mt-1">{l.address}</p></div></li>
                  ))}
                </ul>
              </Reveal>
              <Reveal delay={100}>
                <h2 className="font-mono-label text-[var(--red)] mb-6">Direct</h2>
                <ul className="space-y-5">
                  {details.map(([Icon, label, value, href]) => (
                    <li key={label} className="flex items-center gap-4">
                      <span className="w-11 h-11 grid place-items-center rounded-full border border-[var(--line-strong)]"><Icon className="w-4 h-4" /></span>
                      <div><p className="font-mono-label text-[var(--muted)]">{label}</p>{href ? <a href={href} className="hover:text-[var(--red)] transition-colors">{value}</a> : <p>{value}</p>}</div>
                    </li>
                  ))}
                </ul>
              </Reveal>
            </div>

            <Reveal delay={150} className="lg:col-span-7">
              <div className="rounded-3xl border border-[var(--line-strong)] bg-[var(--surface)] p-8 sm:p-12">
                {submitted ? (
                  <div className="text-center py-10" role="status">
                    <CheckCircle className="w-14 h-14 mx-auto text-emerald-500 mb-6" />
                    <h3 className="font-display text-5xl mb-3">Thank you.</h3>
                    <p className="text-[var(--muted)]">We’ll be in touch shortly.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-8">
                    <h3 className="font-display text-4xl">Send us a message</h3>
                    <div className="grid sm:grid-cols-2 gap-8">
                      {[['name', 'Full name *', 'text', true], ['email', 'Email *', 'email', true], ['company', 'Company', 'text'], ['phone', 'Phone', 'tel']].map(([n, label, type, req]) => (
                        <label key={n} className="block"><span className="font-mono-label text-[var(--muted)]">{label}</span>
                          <input className="field" type={type} name={n} value={formData[n]} onChange={handleChange} required={req} autoComplete={n} /></label>
                      ))}
                    </div>
                    <label className="block"><span className="font-mono-label text-[var(--muted)]">Service of interest</span>
                      <select className="field" name="service" value={formData.service} onChange={handleChange}>
                        <option value="">Select a service</option>
                        <option value="cybersecurity">Cybersecurity Services</option>
                        <option value="cloud">Cloud Consultancy</option>
                        <option value="fintech">Fintech Solutions</option>
                        <option value="devsecops">DevSecOps</option>
                        <option value="infrastructure">IT Infrastructure</option>
                        <option value="managed">Managed Services</option>
                        <option value="staffing">IT Staffing</option>
                        <option value="other">Other</option>
                      </select></label>
                    <label className="block"><span className="font-mono-label text-[var(--muted)]">Message *</span>
                      <textarea className="field resize-none" name="message" rows={4} value={formData.message} onChange={handleChange} required /></label>
                    <button type="submit" className="btn btn-primary">Send message</button>
                  </form>
                )}
              </div>
            </Reveal>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactPage;
